import React, { Fragment, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import { serviceGetDestinatarios } from '../../api/bitacora-client';
import { FaPlusSquare, FaEdit, FaTrashAlt } from "react-icons/fa";
import AddDestinatario from './add-destinatario';
import { LoadingComponent } from 'recupero-comunes'; 
import Mensajes from '../mensajes'

const Destinatarios = ({cfg_form, idCaso, idImplicado, destinatarios, setDestinatarios}) => {

    const [loading, setLoading] = useState(false);
    const [destinatarioSelect, setDestinatarioSelect] = useState(null);
    //const [destinatarios, setDestinatarios] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [handleSubmit, setHandleSubmit] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [responseData, setResponseData] = useState({});


    const getDestinatarios = async () => {        
        //setLoading(true);
        let query = Buffer.from(JSON.stringify({ idCaso: idCaso})).toString('base64');
        const response = await serviceGetDestinatarios(query);

        setDestinatarios(response);
        //setLoading(false);
    }

    const handleAddMod = (destinatario) => {
        setShowModal(true);
        setDestinatarioSelect(destinatario);
    }
    const handleEliminar = async (destinatario) => {

        setLoading(true);

        const nuevosDest = destinatarios.filter((val) => val.secuenciaDestinatario !== destinatario.secuenciaDestinatario);
        
        setDestinatarios(nuevosDest);

        setLoading(false);
    }
    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { 
            getDestinatarios(null);
        }
    }
    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <div className='mt-2 mb-3'>
                <h6 style={{ fontWeiht: 'bold', color: 'color: rgb(255, 255, 255)'}}>
                    {cfg_form && cfg_form["bitacora-subtitle-destinatarios"]}
                </h6>
                <Card className='mt-1'>
                    <Table striped hover>
                        <thead className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                            <tr>
                                <th style={{ backgroundColor: '#4F517A', color: 'white', fontSize: '14px' }}>{cfg_form && cfg_form["bitacora-grilladest-tipo"]}</th>
                                <th style={{ backgroundColor: '#4F517A', color: 'white', fontSize: '14px' }}>{cfg_form && cfg_form["bitacora-grilladest-destinatario"]}</th>
                                <th style={{ backgroundColor: '#4F517A', color: 'white', textAlign: 'center', fontSize: '14px' }}>{cfg_form && cfg_form["bitacora-grilladest-clasdestino"]}</th>
                                <th style={{ backgroundColor: '#4F517A', color: 'white', fontSize: '14px' }}>{cfg_form && cfg_form["bitacora-agregadest-email"]}</th>
                                <th style={{ backgroundColor: '#4F517A', color: 'white', textAlign: 'center', fontSize: '14px', width: '8%' }}>                                    
                                    <FaPlusSquare
                                        size={20}
                                        color='white'
                                        title="Adicionar Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleAddMod(null)}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {destinatarios && destinatarios.map((pre, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{pre.tipoDestinatario}</td>
                                        <td>{pre.nombreDestinatario}</td>
                                        <td style={{ textAlign: 'center' }}>{pre.glosaClasDestino}</td>
                                        <td>{pre.emailDestinatario}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <FaEdit className='icon'
                                                size={20}
                                                color='gray'
                                                title="Modificar Destinatario"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleAddMod(pre)}
                                            />
                                            {pre.codClasDestino != 270001 &&
                                                <FaTrashAlt className='icon'
                                                    size={20}
                                                    color='gray'
                                                    title="Eliminar Destinatario"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleEliminar(pre)}
                                                />
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Card>
            </div>
            {showToast && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={2000}
                    responseData={responseData}
                ></Mensajes>
            }
            <AddDestinatario
                cfg_form={cfg_form}
                showModal={showModal}
                setShowModal={setShowModal}
                destinatario={destinatarioSelect}
                setHandleSubmit={setHandleSubmit}
                idCaso={idCaso}
                idImplicado = {idImplicado}
                destinatarios={destinatarios}
                setDestinatarios={setDestinatarios}
            />
        </Fragment>
    )
}
export default Destinatarios;